import React, { useEffect, useState } from "react";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

import Header from "../components/Header";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import Statistics from "../components/Statistics";
import OurJourney from "../components/OurJourney";
import VisionValues from "../components/dashboard components/VisionValues";
import DeliveredArea from "../components/dashboard components/forms/DeliveredArea";
import OurFootprint from "../components/dashboard components/OurFootprint";
import OurPartners from "../components/Our Partners";
import ContactForm from "../components/dashboard components/forms/ContactForm"; // ✅ replaced BrochureForm

// ✅ Use environment variable
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AboutUs = () => {
  const [hero, setHero] = useState({});
  const [whoWeAre, setWhoWeAre] = useState({});
  const [journeyData, setJourneyData] = useState({});
  const [deliveredArea, setDeliveredArea] = useState([]);
  const [visionValues, setVisionValues] = useState({});
  const [footprintData, setFootprintData] = useState({});
  const [showContactForm, setShowContactForm] = useState(false); // ✅ renamed

  // const navigate = useNavigate();

  // ===============================
  // Fetch all About Us sections
  // ===============================
  useEffect(() => {
    const fetchData = async () => {
      try {
        // HERO
        const heroRes = await axios.get(`${API_BASE_URL}/about/hero`);
        console.log("Hero Res", heroRes);
        setHero(heroRes.data);

        // WHO WE ARE
        const whoRes = await axios.get(`${API_BASE_URL}/about/who-we-are`);
        console.log("whores", whoRes);
        setWhoWeAre(whoRes.data);

        // JOURNEY
        const journeyRes = await axios.get(`${API_BASE_URL}/about/journey`);
        console.log("journeyres", journeyRes);
        let journeyInfo = journeyRes.data;
        if (journeyInfo && journeyInfo.timeline) {
          try {
            if (typeof journeyInfo.timeline === "string") {
              journeyInfo.timeline = JSON.parse(journeyInfo.timeline);
            }
          } catch (err) {
            console.error("Error parsing timeline:", err);
          }
        }
        setJourneyData(journeyInfo);

        // DELIVERED AREA
        const areaRes = await axios.get(`${API_BASE_URL}/about/delivered-area`);
        setDeliveredArea(areaRes.data);

        // VISION & VALUES
        const visionRes = await axios.get(
          `${API_BASE_URL}/about/vision-values`
        );
        setVisionValues(visionRes.data);

        // FOOTPRINT
        const footprintRes = await axios.get(
          `${API_BASE_URL}/about/footprint`
        );
        setFootprintData(footprintRes.data);
      } catch (error) {
        console.error("Error fetching About Us data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* ================= HERO ================= */}
      <Hero
        slides={[
          {
            images: hero.images || [""],
            title: hero.heading || "",
            subtitle: hero.subheading || "",
            tagline: hero.tagline || "",
            location: hero.location || "",
          },
        ]}
      />

      <Statistics />

      {/* ================= WHO WE ARE ================= */}
       <section className="py-16 px-4 bg-white">
  <div className="container mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

    {/* Image */}
    <div className="w-full">
      <img
        src={whoWeAre.image_url || "/images/About Us (Hero).jpg"}
        alt="About HPR Infra"
        className="w-full aspect-video object-cover rounded-2xl shadow-xl"
      />
    </div>

    {/* Text */}
    <div className="flex flex-col justify-center space-y-4 sm:space-y-5">
      <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
        {whoWeAre.heading || " "}
      </h2>

      {whoWeAre.tagline && (
        <p className="text-xl text-blue-600 font-medium">
          {whoWeAre.tagline}
        </p>
      )}

      <p className="text-gray-600 leading-relaxed text-justify">
        {whoWeAre.content || " "}
      </p>
    </div>

  </div>
</section>

      {/* ================= OUR JOURNEY ================= */}
      <OurJourney
        title={journeyData.title || "Our Journey"}
        timelineData={journeyData.timeline || []}
      />

      {/* ================= VISION & VALUES ================= */}
      <VisionValues visionData={visionValues} />

      {/* ================= DELIVERED AREA ================= */}
      <DeliveredArea deliveredArea={deliveredArea} />

      {/* ================= PARTNERS ================= */}
      <OurPartners />

      {/* ================= OUR FOOTPRINT ================= */}
      <OurFootprint footprintData={footprintData} />

      {/* ================= CALL TO ACTION ================= */}
      <section className="py-16 px-4 bg-gradient-to-br from-green-100 to-blue-100">
        <div className="max-w-5xl mx-auto text-center px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4 sm:mb-6">
            Ready to Explore Our Projects?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-6 sm:mb-8 leading-relaxed">
            Download the brochure, or share your details. 
            Our team will contact
            you within one working day.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => setShowContactForm(true)} // ✅ show popup
              className="w-full sm:w-auto bg-gray-800 text-white px-8 py-3 sm:py-4 rounded-lg font-semibold sm:font-bold text-base sm:text-lg hover:bg-gray-900 transition-all shadow-lg"
            >
              Contact Us
            </button>
          </div>
        </div>
      </section>

      {/* ================= CONTACT FORM POPUP ================= */}
      {showContactForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
          <div className="relative w-full max-w-xl max-h-[90vh] overflow-y-auto bg-white rounded-2xl shadow-2xl p-4 sm:p-6">
            <button
              onClick={() => setShowContactForm(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
            >
              <X size={20} />
            </button>
            <ContactForm onSuccess={() => setShowContactForm(false)} /> {/* ✅ replaced form */}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default AboutUs;
